var map = {
	"./DOI_logo.svg": 65293,
	"./Pathway.svg": 82392,
	"./US-NLM-PubMed-Logo.svg": 21829,
	"./arrowIn.svg": 663,
	"./arrowOut.svg": 4594,
	"./bacteria.svg": 34444,
	"./bacteriaSubProject.svg": 22375,
	"./comparisonSubProject.svg": 37707,
	"./construction.png": 70817,
	"./dna.svg": 64694,
	"./fasta.svg": 68271,
	"./gem.svg": 3143,
	"./gemCell.svg": 3911,
	"./gem_dashboard_visual.png": 18855,
	"./genomeSubProject.svg": 7570,
	"./ncbi_logo.svg": 22156,
	"./phage.svg": 18414,
	"./phi.png": 63438,
	"./phredSubProject.svg": 31526,
	"./phyloTreeSubProject.svg": 75147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74449;